import React from "react";

const Button = ({
  onClick,
  text,
  buttonClass,
  icon,
  type = "button",
  loading,
}) => {
  return (
    <button type={type} onClick={onClick} className={buttonClass}>
      <div className={`flex items-center `}>
        <span>{text}</span>
        {icon && icon}
        {loading && <div className="ml-0-25 loading"></div>}
      </div>
    </button>
  );
};

export default Button;
